import { render } from "./MelebihiTempoh.vue?vue&type=template&id=96ec663e"
import script from "./MelebihiTempoh.vue?vue&type=script&lang=js"
export * from "./MelebihiTempoh.vue?vue&type=script&lang=js"

import "./MelebihiTempoh.vue?vue&type=style&index=0&id=96ec663e&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__